module.exports = __webpack_public_path__ + "static/media/entity-usage_bundle-new.a8591feb.png";